import React from "react";
import LoginSignUp from "./LoginSignUp";

const AuthHome = () => {
  return <LoginSignUp />;
};

export default AuthHome;
